import {connect} from 'react-redux';
import ConfirmSignUp from './ConfirmSignUp';

export default connect(
  ({auth}) => ({
    success: auth.confirmTokenValid
  })
)(ConfirmSignUp);



// WEBPACK FOOTER //
// ./src/components/ConfirmSignUp/index.js